(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artprints-recommend"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations-artprints');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            initSamples();

            /* --- Tabs --- */
          	let tabWrapperBtns = $(".tab-wrapper .tab-button").toArray();
          	let tabs = $(".tab-container .tab").toArray();

          	tabWrapperBtns.forEach((tab, key)=>{

          		tab.addEventListener("click", ()=>{

          			if($(tab).hasClass("active")) return;

          			let activeBtn = $(".tab-wrapper .tab-button.active");
          			let activeTab = $(".tab-container .tab.active");

          			activeBtn.removeClass("active");
          			activeTab.removeClass("active");

          			$(tab).addClass("active");
          			$(tabs[key]).addClass("active");
          		});
          	});

            document.querySelectorAll(".item.is-wallpaper, .item.has-color-variants").forEach(el => { new WallpaperItem(el); });

          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  if (!customElements.get('product-recommendations-artprints')) {
    customElements.define('product-recommendations-artprints', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
var dropDown = document.querySelector('#dropDown');
dropDown.addEventListener('click', function() {
    dropDown.classList.toggle('active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-old"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-bkp"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-cp"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.hasLoadedRecommendations = false;
      this.swiperInitAttempts = 0;

      if (this.querySelector('.product-recommendations-cp__slide')) {
        this.hasLoadedRecommendations = true;
        this.classList.add('product-recommendations--loaded');
        this.initializeContent();
        return;
      }

      this.intersectionObserver = new IntersectionObserver((entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        this.loadRecommendations();
      }, { rootMargin: '0px 0px 200px 0px' });
      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    loadRecommendations() {
      if (this.hasLoadedRecommendations) return;
      this.hasLoadedRecommendations = true;

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations-cp');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (this.querySelector('.product-recommendations-cp__slide')) {
            this.classList.add('product-recommendations--loaded');
          }

          this.initializeContent();
        })
        .catch(e => {
          console.error(e);
        });
    }

    initializeContent() {
      this.bindProductCardSwatches();
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => this.initSwiper());
      });
    }

    initSwiper() {
      const carousel = this.querySelector('.product-recommendations-cp__swiper');
      if (!carousel) return;

      if (typeof window.Swiper !== 'function') {
        if (this.swiperInitAttempts < 40) {
          this.swiperInitAttempts += 1;
          window.setTimeout(() => this.initSwiper(), 100);
        }
        return;
      }

      if (this.swiper) {
        this.swiper.destroy(true, true);
      }

      const desktopColumns = Number(this.dataset.columnsDesktop) || 4;
      this.swiper = new Swiper(carousel, {
        slidesPerView: 1.25,
        slidesPerGroup: 1,
        spaceBetween: 16,
        watchOverflow: false,
        allowTouchMove: true,
        pagination: {
          el: carousel.querySelector('.product-recommendations-cp__pagination'),
          clickable: true
        },
        breakpoints: {
          750: {
            slidesPerView: desktopColumns,
            slidesPerGroup: desktopColumns,
            spaceBetween: 24
          }
        }
      });

      this.updateSwiperAfterImagesLoad(carousel);
    }

    updateSwiperAfterImagesLoad(carousel) {
      const images = carousel.querySelectorAll('img');
      let pending = images.length;

      if (!pending) {
        if (this.swiper) this.swiper.update();
        return;
      }

      const onImageSettled = () => {
        pending -= 1;
        if (pending <= 0 && this.swiper) this.swiper.update();
      };

      images.forEach((img) => {
        if (img.complete) {
          onImageSettled();
        } else {
          img.addEventListener('load', onImageSettled, { once: true });
          img.addEventListener('error', onImageSettled, { once: true });
        }
      });
    }

    bindProductCardSwatches() {
      if (this.productCardSwatchHandlerBound) return;

      this.addEventListener('change', (event) => {
        const swatchInput = event.target.closest('.product-card__swatch-input');
        if (!swatchInput) return;

        const card = swatchInput.closest('.product-card');
        if (!card) return;

        const cardImage = card.querySelector('.product-card__image');
        if (!cardImage) return;

        const nextImageSrc = swatchInput.dataset.imageSrc;
        if (nextImageSrc) cardImage.src = nextImageSrc;

        const nextImageAlt = swatchInput.dataset.imageAlt;
        if (nextImageAlt) cardImage.alt = nextImageAlt;

        const variantId = swatchInput.dataset.variantId;
        if (variantId) {
          card.querySelectorAll('a.link-wrapper, .headline-container h1 a').forEach((link) => {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set('variant', variantId);
            link.href = `${url.pathname}${url.search}${url.hash}`;
          });
        }
      });

      this.productCardSwatchHandlerBound = true;
    }
  }

  if (!customElements.get('product-recommendations-cp')) {
    customElements.define('product-recommendations-cp', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-reccomendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  if (!customElements.get('product-reccomendations')) {
    customElements.define('product-reccomendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
